module.exports = __webpack_public_path__ + "static/img/i6.15489a4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/iot/eng/i6.png
// module id = vvbp
// module chunks = 0